<template>
  <div id="tracking">
    <section>
      <v-parallax src="/img/spaghetti.jpg" height="500" style="padding: 0;">
        <v-layout
          id="hero"
          column
          align-center
          justify-center
          class="white--text"
        >
          <h1 class="white--text mb-2 display-1 text-center">
            Доставка как конкурентное преимущество
          </h1>
          <div class="subheading mb-4 text-center">
            Увеличьте конверсию и количество повторных заказов с помощью
            персонализированного, основанного на данных подхода к доставке.
          </div>
          <v-btn class="mt-12" color="primary" dark large to="demo_request"
            >Превратить</v-btn
          >
        </v-layout>
      </v-parallax>
    </section>

    <extra ipadh="/img/tracking_monitor.png" dark>
      <pre ru>
        # Подробное, брендированное отслеживание заказов

        * Постоянно держите клиентов в курсе судьбы их заказа, чтобы они не волновались и не перегружали ваших менеджеров
        * Честно сообщайте о задержках в доставке, чтобы завоевать доверие.
        * Отправляйте обновления статуса заказа в удобный для каждого покупателя канал связи — мессенджеры, соцсети, эл. почта, СМС.
      </pre>
    </extra>

    <extra sparkle="/img/samara_voronoy.svg" right>
      <pre ru>
        # Визуализируйте ваши данные в реальном времени
      </pre>
    </extra>

    <extra dark>
      <template #image>
        <v-img src="/img/red_nike.jpg" id="red_nike_on_gray" />
      </template>

      <template #ru>
        <h1 class="mb-10">Живой пример виджета отслеживания</h1>
        Короткая ссылка для отслеживания, для отправки в СМС:
        <a href="https://xpo.st/3">xpo.st/1</a><br />
        Ведёт на ваш сайт, где вы можете предложить клиенту дополнительные
        товары.
        <div id="extrapost-tracking">
          <img width="50%" src="/img/extrapost_spinner.svg" />
        </div>
      </template>
    </extra>
  </div>
</template>

<script>
import "@/tracking.js";

export default {
  mounted() {
    /* eslint no-undef: 0 */
    ExtraTracking.init({
      token: "F2lFf8Fkr4mZ5NXKFs6o2i1jbWWeT4GEjXOWztAqGCfm",
      tracker_id: "n5vrtCemKH",
      // server: "http://localhost:5555",
      // token: "nlBAK7eoInduNfRkyVv8mkSsjLjbMXlEBc1DjyaBKctr",
      // tracker_id: "UFbkCxOLx3",
      target_id: "extrapost-tracking"
    });
  }
};
</script>

<style>
#extrapost-tracking h1 {
  margin-top: 1em;
  margin-bottom: 1em;
}

#extrapost-tracking ul {
  margin-left: -0.5em;
}

#red_nike_on_gray .v-image__image {
  background-blend-mode: multiply;
  background-color: rgb(238, 238, 238);
}
</style>
